import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createStore } from './create-store';

const DEFAULT_DATE_RANGE = [dayjs().subtract(1, 'months'), dayjs()];

export interface IWhPerformanceFilter {
  date?: Dayjs[];
}

type TState = {
  filters: IWhPerformanceFilter;
};

type TActions = {
  setFilters: (value: IWhPerformanceFilter | undefined) => void;
};

export const useWhPerformanceFiltersStore = createStore<TState & TActions>(
  (set) => ({
    filters: { date: DEFAULT_DATE_RANGE },
    setFilters: (filters: IWhPerformanceFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'wh-performance-filters-store',
);
